<template>
  <div class="px-5 sm:px-6 lg:px-10 py-6" v-cloak>
    <!-- Title (alone) -->
    <div class="mb-8">
      <h1 class="text-3xl font-bold text-gray-900 leading-7">Authentication</h1>
    </div>

    <!-- Table only (no header controls) -->
    <DynamicTable
      wrapperClass="max-w-full"
      :rows="rows"
      :columns="columns"
      :rowsPerPage="10"
      :rowsPerPageOptions="[10, 20, 50]"
      :showHeader="false"
    >
      <!-- Identifier column -->
      <template #identifier="{ row }">
        <span class="text-gray-800">{{ row.identifier }}</span>
      </template>

      <!-- Action column -->
      <template #action="{ row }">
        <div class="flex items-center justify-center">
          <button
            type="button"
            class="inline-flex items-center gap-2 text-gray-700 hover:text-gray-900"
            @click="openVideo(row)"
          >
            <span class="text-base leading-none">▶</span>
            <span class="text-sm">video</span>
          </button>
        </div>
      </template>
    </DynamicTable>

    <!-- Video Modal (optional, same simple style) -->
<div v-if="videoModalOpen" class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50">
      <div class="bg-white w-[720px] max-w-[92vw] rounded-2xl shadow-lg p-6 relative">
        <button
          type="button"
          class="absolute right-4 top-4 w-8 h-8 rounded-full hover:bg-gray-100 flex items-center justify-center"
          @click="closeVideo"
          aria-label="Close"
        >
          ✕
        </button>

        <h3 class="text-lg font-bold text-center mb-5">Video</h3>

        <div class="rounded-xl border border-gray-200 overflow-hidden bg-black">
          <!-- if you have video url from API, put it in selectedVideoUrl -->
          <video
            v-if="selectedVideoUrl"
            :src="selectedVideoUrl"
            controls
            class="w-full h-[360px] object-contain"
          ></video>

          <!-- placeholder if no url -->
          <div v-else class="w-full h-[360px] flex items-center justify-center text-white/70">
            No video url
          </div>
        </div>

        <div class="mt-5 flex justify-center">
          <button
            type="button"
            class="h-10 px-6 rounded-full font-bold text-white"
            style="background-color:#5B9AC5"
            @click="closeVideo"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicTable from "@/components/DynamicTable.vue";

export default {
  name: "Authentication",
  components: { DynamicTable },
  data() {
    return {
      rows: [
        { id: "000", identifier: "[Message content]", date: "[Date]", time: "[Time]", video_url: "" },
        { id: "000", identifier: "[Message content]", date: "[Date]", time: "[Time]", video_url: "" },
        { id: "000", identifier: "[Message content]", date: "[Date]", time: "[Time]", video_url: "" },
        { id: "000", identifier: "[Message content]", date: "[Date]", time: "[Time]", video_url: "" },
        { id: "000", identifier: "[Message content]", date: "[Date]", time: "[Time]", video_url: "" },
      ],
      columns: [
        { key: "id", label: "ID", align: "center", width: "90px" },
        { key: "identifier", label: "Identifier", align: "center" , width: "320px"},
        { key: "date", label: "Date", align: "center", width: "180px" },
        { key: "time", label: "Time", align: "center", width: "160px" },
        { key: "action", label: "Action", align: "center", width: "200px" },
      ],

      videoModalOpen: false,
      selectedVideoUrl: "",
      selectedRow: null,
    };
  },
  methods: {
    openVideo(row) {
      this.selectedRow = row;
      this.selectedVideoUrl = row?.video_url || "";
      this.videoModalOpen = true;
    },
    closeVideo() {
      this.videoModalOpen = false;
      this.selectedVideoUrl = "";
      this.selectedRow = null;
    },
  },
};
</script>

<style scoped>
@reference "tailwindcss";
</style>
